<template>
  <v-container fluid id="docForm">
    <v-card>
      <v-toolbar color="secondary" dense flat>
        <v-toolbar-title>Transfer Draft Preview</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/stock-transfer">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <div style="font-weight: bold; font-size: 16px; margin-top: 10px">
              From:
              <span class="custom-accent">{{ transferDraft.fromStore && transferDraft.fromStore.Name }}</span>
            </div>
          </v-col>

          <v-col cols="12" md="3">
            <div style="font-weight: bold; font-size: 16px;">
              To: <span class="custom-accent">{{ transferDraft.customer && transferDraft.customer.Name }}</span><br>
              <span> Branch / Shop: {{ transferDraft.toStore && transferDraft.toStore.Name }}</span>
            </div><br>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-btn text @click="printViaThermal" color="primary" class="float-right">
              <v-icon color="black" left>mdi-file-pdf-box</v-icon> Print Via Thermal
            </v-btn>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <span style="float: right" class="style-18">Total Value: {{ transferDraft.DocTotal | currency }}</span>
            <br />

            <v-btn text @click="printDraft" color="accent" class="float-right">
              <v-icon color="black" left>mdi-file-pdf-box</v-icon> Print Draft
            </v-btn>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row dense class="subtitle-2 text--primary mt-2">
          <v-col cols="12" xs="12" sm="9" md="9">
            <v-btn text @click.native="transferDialog = true" color="accent" class="mt-1">
              <v-icon left>mdi-plus</v-icon>Add Item To List
            </v-btn>
          </v-col>

          <v-col cols="12" xs="12" sm="3" md="3">
            <span v-if="dateReadonly == 'Y' && role != 3" style="font-weight: bold; font-size: 16px">Date: {{ date
            }}</span>
            <DatePicker v-else @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12">
            <v-data-table :mobile-breakpoint="0" light dense :items-per-page="pageItems" :headers="headers"
              :items="transferList" item-key="id" hide-default-footer disable-sort>

              <template v-slot:item.index="{ index }">
                <span>{{ index + 1 }}</span>
              </template>


              <!-- name template -->
              <template v-slot:item.productName="{ item }">
                <span v-if="IsDistributor == 'Y'">{{ item.name }}</span>
                <span v-if="IsDistributor == 'N'">{{ item.product.Name }}</span>
              </template>
              <!-- end -->

              <!-- selling price template -->
              <template v-slot:item.sellingPrice="{ item }">
                {{
                  item.sellingPrice | currency
                }}
              </template>
              <!-- end -->
              <!--  quantity template -->
              <template v-slot:item.quantity="{ item }">
                <span>{{ item.quantity | currency }}</span>
              </template>
              <!-- end -->

              <!--  total template -->
              <template v-slot:item.total="{ item }">
                <span>{{ (item.quantity * item.sellingPrice) | currency }}</span>
              </template>
              <!-- end -->

              <template v-slot:item.edit="{ item }">
                <v-btn @click="showEditDialog(item)" color="primary" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn @click="showDeleteDialog(item)" color="red" icon>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>


          <v-col cols="12" xs="12" md="4" v-show="IsDistributor == 'Y'">
            <v-autocomplete class="mt-4" style="width: 250px" name="transferCopyTo" dense outlined v-model="copyObj"
              :items="copyData" label="Copy To" item-text="Name" item-value="id"
              @change="copyTransfer"></v-autocomplete>
          </v-col>

          <v-col cols="12" md="4" offset-md="4" class="mt-4" v-show="IsDistributor == 'Y'">
            <v-btn class="float-right" small @click="createTransfer" :loading="loader" :disabled="loader"
              color="primary">
              <v-icon left>mdi-content-save</v-icon> Create Transfer Delivery
            </v-btn>
          </v-col>
        </v-row>

        <!-- transfer modal -->
        <v-dialog v-model="transferDialog" max-width="650px">
          <v-card>
            <v-toolbar dense color="secondary" flat>
              <v-toolbar-title>Stock Transfer</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="transferDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row dense>
                  <v-col cols="12" xs="12" md="12">
                    <v-autocomplete autocomplete="off" v-model="select" :isloading="isLoading" :items="products"
                      :search-input.sync="searchProducts" @change="setTransferItem(select)" item-text="Name"
                      item-value="id" cache-items class="mt-2" flat hide-no-data hide-details label="Search Product"
                      outlined dense></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="3">
                    <span class="style-16" style="color: red">{{ transferItem.ItemCode }}</span>
                  </v-col>

                  <v-col cols="12" md="9">
                    <span class="style-16">{{ transferItem.ProductName }}</span>
                  </v-col>

                  <v-col cols="12" xs="12" md="6">
                    <v-text-field autocomplete="off" type="number" v-model="transferItem.AvailableQty"
                      label="Available Qty" outlined dense filled readonly></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" md="6">
                    <v-text-field autocomplete="off" type="number" v-model="transferItem.TransferQty"
                      label="Transfer Qty" outlined dense @input="qtyChanged(transferItem)"></v-text-field>
                  </v-col>

                  <v-col cols="6" xs="6" md="6">
                    <v-text-field autocomplete="off" type="text" name="goodsReceiptUom" filled outlined readonly dense
                      value="Unit(s)" v-if="transferItem.ManualStatus == 'Y'"></v-text-field>
                    <v-autocomplete autocomplete="off" v-else dense outlined single-line v-model="transferItem.UomEntry"
                      :items="transferItem.ugp1" label="UOM" item-text="UomName" item-value="UomId"
                      @change="uomChanged(transferItem)"></v-autocomplete>
                  </v-col>

                  <v-col cols="12" xs="12" md="6">
                    <v-text-field filled readonly v-model="transferItem.StockBal" label="Remaining Qty" outlined
                      dense></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" md="6" v-show="role == 3">
                    <span class="style-16">Buying Price: {{ transferItem.BuyingPrice }}</span>
                  </v-col>

                  <v-col cols="12" xs="12" md="6" v-show="role == 3">
                    <span class="style-16">Cost Price: {{ transferItem.SellingPrice }}</span>
                  </v-col>

                  <v-col cols="12" xs="12" md="12">
                    <v-text-field v-model="transferItem.ref1" label="Ref No./ IMEI" outlined dense></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="primary" @click="addRow" :loading="loader" :disabled="loader">
                      <v-icon left>mdi-plus</v-icon>Add To List
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of modal -->

        <!-- transfer edit modal -->
        <v-dialog v-model="editDialog" max-width="650px">
          <v-card>
            <v-toolbar dense color="secondary" flat>
              <v-toolbar-title>Edit Stock Transfer</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="editDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row dense>
                  <v-col cols="12">
                    <span class="style-18">{{ editItem.product && editItem.product.Name }}</span>
                  </v-col>

                  <v-col cols="12" xs="12" md="6">
                    <v-text-field autocomplete="off" type="number" v-model="editItem.quantity" label="Transfer Qty"
                      outlined dense></v-text-field>
                  </v-col>


                  <v-col cols="12" xs="12" md="6">
                    <v-text-field autocomplete="off" type="number" v-model="editItem.sellingPrice" label="Price"
                      outlined dense></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" md="12">
                    <span class="style-18">Total: {{ editItem.quantity * editItem.sellingPrice | currency }}</span>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="primary" @click="editTransfer" :loading="loader">
                      <v-icon left>mdi-content-save</v-icon> Edit Transfer
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of modal -->

        <v-dialog v-model="deleteDialog" max-width="700px">
          <v-card>
            <v-toolbar dense color="secondary" flat>
              <v-toolbar-title> Delete draft row record</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="deleteDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row class="subtitle-2 text--primary">
                  <v-col cols="12">
                    <h4>
                      Are you sure you want to delete the following?
                    </h4>
                  </v-col>

                  <v-col cols="12">
                    <span style="color: red">{{ activeTransferItem.product && activeTransferItem.product.Name }}</span>
                  </v-col>

                  <v-col cols="12">
                    <span>Qty: {{ activeTransferItem && activeTransferItem.quantity }}</span>
                  </v-col>

                  <v-col cols="6">
                    <v-btn color="accent" @click="deleteRow" :loading="loader">
                      <v-icon left>mdi-delete</v-icon> Yes, Delete
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <!-- snackbar -->
            <snackbar ref="snackbar"></snackbar>
          </v-card>
        </v-dialog>

        <snackbar ref="snackbar"></snackbar>

        <!-- pdf preview -->
        <pdf-preview ref="pdfPreview"></pdf-preview>
        <!-- end -->

        <!-- printer div -->
        <div id="print" v-show="showPrinterDiv" style>

          <div v-for="(item, index) in receiptHeaders" :key="index" style="font-size: 16px; text-align: center;">
            <div>
              <span style="text-align: center;"> {{ item.rowText }}</span>

            </div>
          </div>
          <br />

          <!-- section 1 -->
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <div style="text-align: center;">
              <span style="font-size: 20px; font-weight: bold; margin-top: 30px;">STOCK TRANSFER DELIVERY</span><br>
            </div>
          </div>
          <!-- end -->


          <!-- from -->
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <div style="text-align: center;">
              <span style="font-size: 18px; font-weight: bold;">From: {{ transferDraft.fromStore &&
                transferDraft.fromStore.Name
                }}</span>
            </div>
          </div>
          <br>
          <!-- end -->


          <!-- to store -->
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <div style="text-align: center;">
              <span style="font-size: 18px; font-weight: bold;">To: {{ transferDraft.toStore &&
                transferDraft.toStore.Name
                }}</span>
            </div>
          </div>
          <!-- end -->

          <span>-------------------------------------------------------</span>

          <div>
            <span style="font-size: 16px;">Date: {{ transferDraft.CreatedAt | date }}</span>
          </div>

          <span>-------------------------------------------------------</span>
          <div
            style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between; font-weight: bold;">
            <span style="width: 70%; text-align: left; padding-left: 2px;">Item</span>

            <span style="width: 15%; text-align: left;">Qty</span>

            <span style="width: 15%; text-align: left;">Unit</span>

          </div>
          <span>-------------------------------------------------------</span>

          <div v-for="(item, index) in transferList" :key="index"
            style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between; font-weight: bold;">
            <span style="width: 70%; text-align: left; padding-left: 2px; font-weight: bold">{{
              item.product.Name }}
            </span>

            <span style="width: 15%; text-align: left; padding-left: 2px; font-weight: bold">{{
              item.quantity }}
            </span>

            <span style="width: 15%; text-align: left; padding-left: 2px; font-weight: bold">{{
              item.uom && item.uom.UomName }}
            </span>
          </div><br>

          <span>-------------------------------------------------------</span>

          <div>
            <!-- Transferred by: ______________________ -->
          </div>

        </div>
        <!-- end of printing div -->

      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { http, host } from "@/common/index";
export default {
  components: {},
  computed: {
    IsDistributor() {
      return localStorage.getItem("IsDistributor");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    userId() {
      return localStorage.getItem("userId");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    totalAmount() {
      let total = 0;
      if (
        typeof this.transferList != "undefined" &&
        this.transferList.length > 0
      ) {
        return this.transferList
          .map(item => {
            let Qty = 0;
            let SellingPrice = 0;
            if (item.SellingPrice) {
              SellingPrice = item.SellingPrice;
            }
            if (item.TransferQty) {
              Qty = item.TransferQty;
            }
            const amount = Qty * SellingPrice;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    }
  },
  data() {
    return {
      activeTransferItem: {},
      showPrinterDiv: false,
      editDialog: false,
      deleteDialog: false,
      copyObj: null,
      copyData: [{ Name: "Stock Transfer Delivery", id: 12 }],
      transferDraft: {},
      selectedCustomer: null,
      fromStore: {},
      search: null,
      enableCreate: true,
      isLoading: false,
      smsRef: null,
      select: "",
      searchingProduct: false,
      searchProducts: null,
      products: [],
      customers: [],
      receiptHeaders: [],
      userItem: {},
      userDialog: false,
      TransferDeficit: "",
      pageItems: 500,
      loader: false,
      editItem: {},
      damagedItem: {},
      transferItem: {},
      generalSettings: {},
      store: null,
      UserSign2: null,
      stores: [],
      users: [],
      date: new Date().toISOString().substr(0, 10),
      dialog: false,
      damageDialog: false,
      transferDialog: false,
      dateReadonly: "N",
      searchCustomers: null,
      todayDate: new Date().toISOString().substr(0, 10),
      headers: [
        { text: "NO:", value: "index" },
        { text: "Item Code", value: "itemCode" },
        { text: "Product Name", value: "productName" },
        { text: "Transfer Qty", value: "quantity" },
        { text: "Unit", value: "uom.UomName" },
        { text: "Cost Price", value: "sellingPrice" },
        { text: "Total", value: "total" },
        { text: "Ref No.", value: "RefNo" },
        { text: "Edit", value: "edit" },
        { text: "Action", value: "action" }
      ],
      inventory: [],
      transferList: []
    };
  },
  watch: {
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
    searchCustomers(val) {
      if (val && val !== this.select && this.queryCustomers(val)) {
        this.queryCustomers(val);
      }
    },
    "$route.params.id": {
      handler: "getById",
      immediate: true
    }
  },
  methods: {
    getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/stock-transfer-drafts/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.transferDraft = res.ResponseData.transferDraft;
            self.transferList = res.ResponseData.draftRows;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printDraft() {
      var isDistributor = localStorage.getItem("IsDistributor");
      var url = "";
      // if (isDistributor == "N") {
      //   url = "/print-supermarket-delivery-document/10/" + this.Invoice.id;
      // }

      if (isDistributor == "Y") {
        url = "/print-supermarket-stock-draft/" + this.transferDraft.id;
      }

      const apiUrl = `${host}${url}`;
      const self = this;
      http.get(apiUrl, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        self.$refs.pdfPreview.show(fileUrl);
      });
    },
    showDeleteDialog(item) {
      this.activeTransferItem = item;
      this.deleteDialog = true;
    },
    showEditDialog(item) {
      this.editItem = item;
      this.editDialog = true;
    },
    resetLoader() {
      this.$store.commit("loader", false);
      this.$store.commit("btnLoader", false);
      this.$refs.snackbar.show("Done", "green");
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      var customerId = 0;

      if (this.IsDistributor == "Y") {
        customerId = this.transferDraft.customer.id;
      }


      const data = {
        searchText: searchText,
        CustomerId: customerId
      };
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null) {
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    queryCustomers(searchText) {
      const self = this;
      const url = "/customers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            // if array length > 1
            self.customers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.date = date;
    },
    openCreate() {
      this.userDialog = true;
    },
    copyTransfer() { },
    getBranches(id) {
      const self = this;
      var url = `/stores/customers/${id}`;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    addRow() {
      if (this.transferItem.TransferQty == undefined) {
        this.$refs.snackbar.show(`Please fill the quantity!`, "red");
        return;
      }

      // if (this.transferItem.TransferQty > this.transferItem.AvailableQty) {
      //   this.$refs.snackbar.show(
      //     `Insufficient Stock Available: ${this.transferItem.AvailableQty}`,
      //     "red"
      //   );

      //   return;
      // }

      var item = this.transferItem;
      var draftId = this.transferDraft.id;

      const self = this;
      this.loader = true;

      var details = {
        stockTransferId: parseInt(draftId),
        itemCode: item.ItemCode,
        productId: parseInt(item.productId),
        name: item.ProductName,
        quantity: parseFloat(item.TransferQty),
        uomEntry: parseInt(item.UomEntry),
        buyingPrice: parseFloat(item.BuyingPrice),
        sellingPrice: parseFloat(item.SellingPrice),
        refNo: item.refNo
      };

      var url = `/stock-transfer-draft-add-row/${draftId}`;

      this.$store
        .dispatch("post", { url, data: details })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.transferDialog = false;
            self.getById(draftId);
            self.transferItem = {};
            this.$refs.snackbar.show("Item added successfully !", "green");
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        }).finally(() => {
          self.loader = false;
        });

    },
    uomChanged(data) {
      const self = this;

      // get converted qty
      let details = {
        productId: parseInt(data.productId),
        quantity: parseFloat(data.TransferQty),
        uomEntry: parseInt(data.UomEntry)
      };

      let uomEntryName = "";

      // uom name
      let ugp1 = data.ugp1;
      let ugp1Record = {};
      if (data.ManualStatus == "N") {
        ugp1Record = ugp1.find(record => {
          return record.UomId === data.UomEntry;
        });
        uomEntryName = ugp1Record.UomName;
      } else {
        uomEntryName = "Pcs";
      }
      // end

      const url = `/converted-qty`;

      // self.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data: details })
        .then(res => {
          if (res.ResultCode == 1200) {
            const StockBalance = data.AvailableQty - res.ResponseData;
            self.transferItem = {
              ...self.transferItem,
              BuyingPrice: ugp1Record.BuyingPrice,
              SellingPrice: ugp1Record.SellingPrice,
              StockBal: StockBalance,
              uomEntryName: uomEntryName
            };
            // self.$store.commit("loader", false);
          } else {
            // self.$store.commit("loader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });

      if (!data.TransferQty) {
        this.$refs.snackbar.show("Please fill the quantity!", "red");
      }
    },
    qtyChanged(data) {
      const self = this;
      const available = data.AvailableQty;
      if (data.TransferQty) {
        // get converted qty
        let details = {
          productId: parseInt(data.productId),
          quantity: parseFloat(data.TransferQty),
          uomEntry: data.UomEntry ? parseInt(data.UomEntry) : 0
        };
        const url = `/converted-qty`;
        this.$store
          .dispatch("post", { url, data: details })
          .then(res => {
            if (res.ResultCode == 1200) {
              const StockBalance = available - res.ResponseData;
              self.transferItem = {
                ...self.transferItem,
                StockBal: StockBalance
              };
            } else {
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch(err => {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show(err, "red");
          });
      } else {
        self.transferItem = {
          ...self.transferItem,
          StockBal: available
        };
      }
    },
    deleteRow() {
      const self = this;
      const url = `/delete-stock-transfer-draft-row/${self.activeTransferItem.id}`;
      this.loader = true;
      this.$store
        .dispatch("remove", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.activeTransferItem = {};
            location.reload();
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    setTransferItem(id) {
      const self = this;
      // fetch the product from database

      var storeId = this.transferDraft.fromStore.id;

      var url = "";
      if (this.IsDistributor == 'N') {
        url = `/product-inventory/${id}/${storeId}`;
      }

      if (this.IsDistributor == 'Y') {
        var customerId = this.transferDraft.customer.id
        url = `/product-inventory-by-customer/${id}/${storeId}/${customerId}`;
      }

      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;

            let currentItem = {};
            const LineNum = new Date().getTime();
            currentItem.refNo = "";
            currentItem.LineNum = LineNum;
            currentItem.Quantity = null;
            currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
            currentItem.productId = id;
            if (self.IsDistributor == "N") {
              currentItem.ItemCode = "";
            }

            if (self.IsDistributor == "Y") {
              if (product.SupermarketCode == "") {
                currentItem.ItemCode = product.ItemCode;
              }

              if (product.SupermarketCode != "") {
                currentItem.ItemCode = product.SupermarketCode;
              }

            }

            currentItem.ProductName = product.Name;
            currentItem.AvailableQty = product.AvailableQty;
            currentItem.StockBal = product.AvailableQty;
            // end

            if (product.HasUom === 0) {
              // check if manual yes and assign
              var sellingPrice = product.sellingPrice;
              var buyingPrice = product.buyingPrice;
              currentItem.BuyingPrice = buyingPrice;
              currentItem.SellingPrice = sellingPrice;
              currentItem.currentPrice = sellingPrice;
              currentItem.uomEntryName = "Pc(s)";
              currentItem.UomEntry = 0;
              // end of manual yes
            }

            // start of manual No status
            if (product.HasUom === 1) {
              let ugp1Data = product.ugp1;
              const ugp1Record = ugp1Data.find(record => {
                return record.UomEntry === product.SUoMEntry;
              });
              currentItem.ugp1 = product.ugp1;
              currentItem.UomEntry = product.SUoMEntry;
              currentItem.uomEntryName = ugp1Record.UomName;
              currentItem.BuyingPrice = ugp1Record.BuyingPrice;
              currentItem.SellingPrice = ugp1Record.SellingPrice;
            }

            self.transferItem = { ...self.transferItem, ...currentItem };

            this.select = null;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    createTransfer() {
      if (this.date == null || this.date == undefined) {
        this.$refs.snackbar.show("Please select date!", "red");
        return;
      }

      if (this.transferList.length <= 0) {
        this.$refs.snackbar.show(
          "You must add at least one item to transer!",
          "red"
        );
        return;
      }

      if (this.IsDistributor == 'Y' && (this.copyObj == null || this.copyObj == undefined)) {
        this.$refs.snackbar.show(
          "Please select the copy option !",
          "red"
        );
        return;
      }

      const url = `/accept-stock-transfer/${this.transferDraft.id}`;
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$router.push("/transfer-deliveries");
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        })
        .finally(() => {
          self.loader = false;
        });

    },
    editTransfer() {
      const data = {
        quantity: parseFloat(this.editItem.quantity),
        price: parseFloat(this.editItem.sellingPrice)
      };

      const url = `/edit-stock-transfer-draft/${this.editItem.id}`;
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("put", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.editDialog = false;
            self.getById(self.transferDraft.id);
            self.$refs.snackbar.show("updated successfully", "green");
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        }).finally(() => {
          self.loader = false;
          self.editDialog = false;
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReceiptHeaders() {
      this.$store.commit("btnLoader", false);
      const self = this;
      this.$store
        .dispatch("get", `/get-receipt-headers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.receiptHeaders = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printViaThermal() {
      // Get the HTML content you want to print
      const content = document.getElementById("print").innerHTML;

      // Open a new print window
      const printWindow = window.open(
        "",
        "",
        "left=0,top=0,width=100,height=auto,toolbar=0,scrollbars=0,status=0"
      );

      // Write the HTML to the print window, including the content
      printWindow.document.write(`
            <html>
            <head>
                <title>Print</title>
                <style>
                body {
                    width: 80mm;
                    margin: 0 auto;
                }
                @page {
                    size: auto;  /* auto is the current printer page size */
                    margin: 0mm; /* this affects the margin in the printer settings */
                }
                </style>
            </head>
            <body onload="window.print(); window.close();">${content}</body>
            </html>
        `);

      printWindow.document.close();
    },
  },
  created() {
    Promise.all([
      this.getStores(),
      this.getReceiptHeaders()
    ]);
  }
};
</script>

<style lang="scss" scoped></style>